export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.766 4.029A1 1 0 0122 5v13.5a1 1 0 01-1.249.968L12.5 17.344v.131a3.001 3.001 0 01-3.688 2.921l-.25-.06a3 3 0 01-2.312-2.92v-1.831L2.724 14.57A1 1 0 012 13.609v-4.26a1 1 0 01.766-.972l18-4.348zM8.25 17.417c0 .463.32.867.771.973l.25.059a1 1 0 001.229-.974v-.668l-2.25-.646v1.256zM4 10.135v2.721l7.749 2.23L20 17.21V6.27L4 10.135z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};